export default {"src":"/_next/static/media/integrations-mob.616112a3.svg","height":386,"width":340,"blurWidth":0,"blurHeight":0};